module.exports = __webpack_public_path__ + "img/hero-icon-ball-2.cb914ace.svg";